
try {
	window.$ = window.jQuery = require('jquery');
    window.bootstrap = require('bootstrap');
	window.Alpine = Alpine;
} catch (e) {}

require('./jquery.mask.min.js');
require('./masks');

require('./accessible-menu.js');
require('./cfp-toast.js')
require('./modal.js')
